import { render, staticRenderFns } from "./ZxcgcsEdit.vue?vue&type=template&id=2309c860&scoped=true"
import script from "./ZxcgcsEdit.vue?vue&type=script&lang=js"
export * from "./ZxcgcsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309c860",
  null
  
)

export default component.exports